import { makeStyles } from '@material-ui/core'

import LoginWithGoogleButton from 'components/SSOButtons/LoginWithGoogleButton'
import Title from 'components/Title'

import { useRegistrationData } from '../../SignUpProvider/sign-up-context'

const useStyles = makeStyles((theme) => ({
  highSchoolName: {
    color: theme.palette.secondary.main,
  },
}))

const GoogleRequired = () => {
  const classes = useStyles()
  const data = useRegistrationData()

  // Arriving from the match confirmation, the school requiring Google is the
  // matched student's rather than the one picked on the way in, which may be
  // "Other" or a school the student guessed at
  const schoolName = data?.matchedStudent?.HighSchool?.HighSchoolName || data?.highSchool?.HighSchoolName

  return (
    <>
      <Title
        title={
          schoolName ? (
            <>
              <span className={classes.highSchoolName}>{schoolName}</span> uses Google to log in
            </>
          ) : (
            'Your school uses Google to log in'
          )
        }
      />
      {/* The school requires Google, so this page offers nothing else to fall back on */}
      <LoginWithGoogleButton
        source="student-signup"
        hasAlternatives={false}
      />
    </>
  )
}

export default GoogleRequired
